import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M11.39 6.333L9.667 4.61 4.277 10 6 11.724l5.39-5.39zm.943-.942l.918-.918a.667.667 0 00.004-.942l-.786-.786a.661.661 0 00-.942.004l-.918.918 1.724 1.724zM3.53 8.863l7.055-7.057a1.995 1.995 0 012.826-.004l.787.786a2 2 0 01-.004 2.827L6 13.61l-2.516-2.518-.534 1.958.497-.128 1.073 1.072-3.47.956L2.393 10 3.53 8.862v.001z',
    ],
    24: [
        'M20.574 2.878l1.18 1.18a3 3 0 01-.007 4.24L9.457 20.589l-3.794-3.793-.834 3.033 1.49 1.623L2 22.63l2.03-7.444L16.333 2.883a2.992 2.992 0 014.24-.006zm-5.649 4.241L6.87 15.175l2.586 2.586 8.055-8.056-2.586-2.586zm2.822-2.821L16.34 5.705l2.586 2.586 1.408-1.407a1 1 0 00.006-1.412l-1.18-1.18a.992.992 0 00-1.412.006z',
    ],
};
const IconEdit = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconEdit.displayName = 'IconEdit';

export { IconEdit };
//# sourceMappingURL=IconEdit.js.map
